import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { PrimaryButton } from 'shared/components/button'
import CertificateCheckIcon from 'shared/icons/certificate-check-icon'
import DownloadIcon from 'shared/icons/download-icon'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import CourseLayout from 'modules/course/components/course-layout'
import useCertificateOfCompletion from 'modules/course/hooks/use-certificate-of-completion'
import { useCourseData } from 'modules/course/hooks/use-course-data'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { getCoursePageLayout } from 'modules/course/layouts/get-course-page-layout'

export default function CertificateOfCompletion() {
  const { t } = useTranslation()
  const { getCertificateLink, isCertificateAvailable } = useCertificateOfCompletion()
  const { courseData } = useCourseData()
  const { findStep, redirectToStep } = useStepRouter()

  useEffect(() => {
    // if (!isCertificateAvailable) {
    //   redirectToStep(findStep())
    // }
  }, [isCertificateAvailable, findStep])

  return (
    <CourseLayout>
      <div className="flex h-fit w-full items-center justify-center rounded-lg bg-background-secondary p-8">
        <div className="flex w-full flex-col items-center justify-center gap-11 rounded-xl border-2 border-dashed border-text-secondary bg-background-tertiary/50 p-10 text-center">
          <CertificateCheckIcon className="text-brand-primary" />
          <h2>{t('course.certificate.page.heading')}</h2>
          <p
            className="max-w-xl text-lg"
            dangerouslySetInnerHTML={{
              __html: t('course.certificate.page.description', { courseName: courseData?.name }),
            }}
          ></p>
          <PrimaryButton href={getCertificateLink()} download target="_blank">
            <DownloadIcon />
            {t('course.certificate.cta')}
          </PrimaryButton>
        </div>
      </div>
    </CourseLayout>
  )
}

CertificateOfCompletion.getLayout = getCoursePageLayout

export const getServerSideProps = withDomainAssets(baseServerSideProps)
